import { useQueries } from "@tanstack/react-query";
import getAdvisor from "../requests/getAdvisor";
import { keyMaker } from "./useGetAdvisor";
const useGetAdvisors = (advisorIds, authConfig) => {
    const advisorQueries = useQueries({
        queries: advisorIds.map((advisorId) => ({
            queryKey: keyMaker(advisorId),
            queryFn: async () => getAdvisor(advisorId, authConfig),
            enabled: !!authConfig,
        })),
    });
    const isLoading = advisorQueries.some((query) => query.isLoading);
    const hasError = advisorQueries.some((query) => query.error);
    const error = advisorQueries.find((query) => query.error)?.error;
    if (isLoading) {
        return { data: undefined, isLoading: true, hasError: false };
    }
    if (hasError) {
        return { data: undefined, isLoading: false, hasError: true, error };
    }
    const data = advisorQueries
        .map((query) => query.data)
        .filter((advisor) => advisor !== undefined);
    return { data, isLoading: false, hasError: false };
};
export default useGetAdvisors;
//# sourceMappingURL=useGetAdvisors.js.map